import React, {memo} from "react";
import {Badge, Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
import {handelOpenModalEditProfile} from "../../../../redux/actions/modals/modalEditProfile";
import {FaHome, FaShoppingCart} from "react-icons/all";

const HeaderBaseWithWideLogo = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {openModalShoppingCard} = props;

    const openModalLoginAndRegister = () => {
        goToPageStores();
        if (!token) {
            dispatch(handelOpenModalLoginAndRegister());
        } else {
            dispatch(handelOpenModalEditProfile());
        }
    }

    const goToPageStores = () => {
        history.push('/stores');
    }

    const {token, profile} = useSelector(state => state.user);
    const {carts} = useSelector(state => state.shoppingCart);
    const {fullname} = profile;

    return (
        <React.Fragment>
            <div id={'box-flex-navigation-fixed'} className='base-scroll-bg-station scroll-bg-fourth-station py-2'>
                <Row>
                    <Col>
                        <div className={'text-left base-box-icons-header-fixed base-box-right-icons-header-fixed'}>
                            <div className={'first-icon-box-right-icons-header-fixed'}>
                                {carts.length > 0 &&
                                <Badge pill variant="danger" id={'badge-numbers-basket-shopping-header'}
                                       className={'float-right'}
                                       onClick={openModalShoppingCard}>
                                    {carts.length}
                                </Badge>}
                                <FaShoppingCart className={'ml-2 base-icons-header-fixed'}
                                                 onClick={openModalShoppingCard}/>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className={'text-center base-box-icons-header-fixed'}>
                            <Link to={'/'} className={'m-auto'}>
                                <img src={'https://fruitmruit.com/icons/fm_logo_ofoghi_new.png'} alt="LOGO"
                                    style={{maxWidth: 200}}/>
                            </Link>
                        </div>
                    </Col>
                    <Col>
                        <div className={'text-right base-box-icons-header-fixed base-box-left-icons-header-fixed'}>
                            <FaHome className={'base-icons-header-fixed'}
                                             onClick={goToPageStores}/>
                            <Button id={'btn-login-and-register-navigation'} onClick={openModalLoginAndRegister}>
                                {!token ? <span>ورود / ثبت نام</span> :
                                    <span>{fullname !== '' ? fullname : 'نام و نام خانوادگی'}</span>
                                }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default memo(HeaderBaseWithWideLogo);
